"use client";

import type { ReactNode } from "react";
import { cn } from "@marketing-sites/utils/cn";
import { Dialog } from "../primitives";
import { InfoIcon } from "./info-icon";

export interface DrlpInfoModalProps {
  /** Dialog title — a11y heading and visible copy. */
  title: string;
  /** Modal body. */
  children: ReactNode;
  /** Width/layout override for the Popup (default ~30rem). */
  popupClassName?: string;
  triggerAriaLabel?: string;
  openMetadata: { analyticsId: string };
  closeMetadata: { analyticsId: string };
}

/** Bordered "i" trigger that opens a light i2y4 modal — the click-to-open
 * sibling of `InfoTooltip`, used where the info body needs links/CTAs. */
export function DrlpInfoModal({
  title,
  children,
  popupClassName,
  triggerAriaLabel = "More information",
  openMetadata,
  closeMetadata,
}: DrlpInfoModalProps) {
  return (
    <Dialog.Root openMetadata={openMetadata} closeMetadata={closeMetadata}>
      <Dialog.Trigger
        aria-label={triggerAriaLabel}
        type="button"
        className="text-current/70 inline-flex cursor-pointer items-center hover:text-current"
      >
        <InfoIcon />
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Viewport>
          <Dialog.Popup className={cn("text-off-black", popupClassName)}>
            <div className="flex flex-col gap-6">
              <Dialog.Title className="text-heading-5">{title}</Dialog.Title>
              {children}
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
